module.exports = __webpack_public_path__ + "static/media/victory.1bed9889.wav";